import Vue from 'vue'

// Multilang
import VueI18n from 'vue-i18n'
import { languages, defaultLocale } from './lang'

import App from './App.vue'
import '@mdi/font/css/materialdesignicons.css'
import router from './router'
import axios from 'axios'
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/src/components/cluster' // replace src with dist if you have Babel issues
import VueGtm from 'vue-gtm'

import Transitions from 'vue2-transitions'
import store from './store/store'

const messages = Object.assign(languages)

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.component('GmapCluster', GmapCluster)
Vue.use(Transitions)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC3ovObhmYElHz_4XxHRiI_Xc5isAWZ7fs',
    // key: 'AIzaSyC3ovObhmYElHz_4XxHRiI_Xc5isAWZ7fs',
    libraries: 'places, distance'
  },
  installComponents: true
})
Vue.use(VueGtm, {
  id: 'GTM-NPCVF9S', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
})
Vue.use(VueI18n) // Multilanguage

export const Event = new Vue()

var i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'en',
  messages
})

new Vue({
  router,
  axios,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
